import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Admin token wins for /admin/* routes
  const adminToken = localStorage.getItem("life101_admin_token");
  const userToken = localStorage.getItem("life101_user_token");
  const url = config.url || "";
  if (url.includes("/admin/") && adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (userToken) {
    config.headers.Authorization = `Bearer ${userToken}`;
  } else if (adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

export function getResults() {
  try {
    const raw = localStorage.getItem("life101_results");
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}
export function storeResults(r) {
  localStorage.setItem("life101_results", JSON.stringify(r));
}
